import { render, staticRenderFns } from "./UserContext.vue?vue&type=template&id=35e38dde&"
import script from "./UserContext.vue?vue&type=script&lang=js&"
export * from "./UserContext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports